import EventChip from '@/components/common/chips/EventChip';
import UserEventsPickerDialog from '@/components/nodes/settings/events/UserEventsPickerDialog';
import { useApplication } from '@/hooks/useApplication';
import { isObject } from '@/util/typeGuards';
import { FC, useEffect, useState } from 'react';
import { ParamProps } from './ParamRenderer';

const ParamUserEvent: FC<ParamProps> = (props) => {
  const { application } = useApplication();

  const [openUserEventsPicker, setOpenUserEventsPicker] = useState(false);
  const [chipText, setChipText] = useState('');

  useEffect(() => {
    if (!isObject(props.initialValue) || !props.configuration.value || !props.initialValue[props.configuration.value])
      return;

    const userEventName = props.initialValue[props.configuration.value] as string;
    const userEventLabel = application.userevents?.find((userevent) => userevent.event === userEventName)?.label;
    setChipText(userEventLabel || userEventName);
  }, [props.initialValue, props.configuration.value]);

  return (
    <>
      <EventChip
        value={props.configuration.value}
        chipText={chipText}
        required={props.configuration.required}
        onClick={() => setOpenUserEventsPicker(true)}
        onDelete={() => {
          props.onChange([props.configuration.value, undefined]);
          setChipText('');
        }}
      />
      <UserEventsPickerDialog
        open={openUserEventsPicker}
        handleSave={(newUserEvent) => {
          props.onChange([props.configuration.value, newUserEvent.event]);
          setOpenUserEventsPicker(false);
        }}
        onClose={() => {
          setOpenUserEventsPicker(false);
        }}
      />
    </>
  );
};
export default ParamUserEvent;
